import DeviceGroup from "../../classes/DeviceGroup";

export interface StateInterface {
  deviceGroups: Array<DeviceGroup>;
}

function state(): StateInterface {
  return {
    deviceGroups: [],
  };
}

export default state;
